import React, { useState, useEffect } from 'react'
import './Reviews.css'
import Steps from '../components/Steps'
import { Link } from 'react-router-dom'

const API_BASE_URL = 'https://malaikabackend.onrender.com/api'

const Reviews = () => {
  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    rating: 5,
    reviewText: '',
    serviceType: 'Birth Doula Support'
  })

  useEffect(() => {
    fetchReviews()
  }, [])

  const fetchReviews = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${API_BASE_URL}/reviews`)
      const data = await response.json()
      
      if (data.success) {
        setReviews(data.data)
      } else {
        setError('Failed to fetch reviews')
      }
    } catch (err) {
      setError('Error connecting to server')
      console.error('Error fetching reviews:', err)
    } finally {
      setLoading(false)
    }
  }

  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : 'A'
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })
  }

  const renderStars = (rating) => {
    return '★'.repeat(rating)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitStatus('submitting')

    try {
      const response = await fetch(`${API_BASE_URL}/reviews`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })

      const data = await response.json()

      if (data.success) {
        setSubmitStatus('success')
        setFormData({
          name: '',
          email: '',
          rating: 5,
          reviewText: '',
          serviceType: 'Birth Doula Support'
        })
        fetchReviews()
        setTimeout(() => {
          setShowModal(false)
          setSubmitStatus(null)
        }, 2000)
      } else {
        setSubmitStatus('error')
        console.error('Submission error:', data.message)
      }
    } catch (err) {
      setSubmitStatus('error')
      console.error('Error submitting review:', err)
    }
  }

  const serviceTypes = [
    'Birth Doula Support',
    'Postpartum Support',
    'Sibling Support',
    'Sleep Training',
    'Breastfeeding Support',
    'Other'
  ]

  return (
    <div>
        <div className='hero-section'>
            <div className='hero-sub-section'>
                <h1 className='hero-header'>Malaika Doulas Clients Reviews</h1>
                <p className='grey'>Experience expert care for pregnancy with our compassionate pregnancy support and doula services, ensuring a healthy journey for you and your baby.</p>
                <div className='row-justify-content-between'>
                  <Link to='/inquiry' className=' button text-decoration-none'>
                      Inquire About Services
                  </Link>
                </div>
            </div>
            
            <div className='hero-sub-section'>
                <img src={require('../assets/sleeping3.jpeg')} alt="Hero" style={{width: '100%', height: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '30px'}} />
            </div>
        </div>

        <div>
            <h2 className='header2'>Our passion at Malaika DOULAS is to provide the most current, evidence-based care with integrity and excellence.</h2>
            <p className='grey'>Our careful attention to detail, depth of experience and commitment to families, has made Malaika DOULAS the leading and most trusted doula practice in both northern and southern California. But don't just take our word for it. See what some of our clients have to say:</p>
        </div>

        <div className='page-reviews-section'>
          {loading ? (
            <div style={{textAlign: 'center', padding: '20px'}}>
              <p>Loading reviews...</p>
            </div>
          ) : error ? (
            <div style={{textAlign: 'center', padding: '20px'}}>
              <p style={{color: 'red'}}>Error: {error}</p>
            </div>
          ) : reviews.length === 0 ? (
            <div style={{textAlign: 'center', padding: '20px'}}>
              <p>No reviews yet. Be the first to share your experience!</p>
            </div>
          ) : (
            reviews.map((review) => (
              <div key={review._id} className='page-review-card'>
                <div className='review-card-upper'>
                  <div className='review-profile-initial'>
                    {getInitial(review.name)}
                  </div>
                  <h3>{review.name}</h3>
                  <span className='yellow'>{renderStars(review.rating)}</span>
                  <p>{formatDate(review.createdAt)}</p>
                  <p className='review-service-type'>{review.serviceType}</p>
                </div>
                <div className='review-card-lower'>
                  <p className='grey'>{review.reviewText}</p>
                </div>
              </div>
            ))
          )}
          
          <div>
            <button 
            className='button text-decoration-none'
            onClick={() => setShowModal(true)}
            style={{marginLeft: '10px', display: 'block', marginTop: '30px'}}
          >
              Add Your Review
          </button>
          </div>
          <Steps />
        </div>

        {/* Review Modal */}
        {showModal && (
          <div className='modal-overlay' onClick={() => setShowModal(false)}>
            <div className='modal-content' onClick={(e) => e.stopPropagation()}>
              <div className='modal-header'>
                <h3>Share Your Experience</h3>
                <button className='close-btn' onClick={() => setShowModal(false)}>×</button>
              </div>
              
              {submitStatus === 'success' ? (
                <div className='success-message'>
                  <p>Thank you for your review! It has been submitted successfully.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className='review-form'>
                  <div className='form-group'>
                    <label>Name *</label>
                    <input
                      type='text'
                      name='name'
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder='Your full name'
                    />
                  </div>

                  <div className='form-group'>
                    <label>Email *</label>
                    <input
                      type='email'
                      name='email'
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder='Your email address'
                    />
                  </div>

                  <div className='form-group'>
                    <label>Service Type *</label>
                    <select
                      name='serviceType'
                      value={formData.serviceType}
                      onChange={handleInputChange}
                      required
                    >
                      {serviceTypes.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>

                  <div className='form-group'>
                    <label>Rating *</label>
                    <div className='star-rating'>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`star-btn ${formData.rating >= star ? 'active' : ''}`}
                          onClick={() => setFormData(prev => ({...prev, rating: star}))}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className='form-group'>
                    <label>Your Review *</label>
                    <textarea
                      name='reviewText'
                      value={formData.reviewText}
                      onChange={handleInputChange}
                      required
                      placeholder='Share your experience with Malaika Doulas...'
                      rows={5}
                    />
                  </div>

                  <div className='form-actions'>
                    <button type='button' onClick={() => setShowModal(false)}>
                      Cancel
                    </button>
                    <button type='submit' disabled={submitStatus === 'submitting'}>
                      {submitStatus === 'submitting' ? 'Submitting...' : 'Submit Review'}
                    </button>
                  </div>

                  {submitStatus === 'error' && (
                    <div className='error-message'>
                      <p>Failed to submit review. Please try again.</p>
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        )}
    </div>
  )
}

export default Reviews